module.exports = __webpack_public_path__ + "img/contact.cc9a6e22.svg";